import { UserCommunication } from '@this+that/models';

import { ShortcutContext } from './types';
import { useEmailListNavigation } from './useEmailListNavigation';

interface UseSpamNavigationProps {
  filteredCommunications: UserCommunication[];
}

export function useSpamNavigation({
  filteredCommunications,
}: UseSpamNavigationProps) {
  return useEmailListNavigation({
    filteredCommunications,
    context: ShortcutContext.SPAM,
  });
}
